import React, { useEffect, useState } from "react";
import { Col, Row, Button, Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getPartnerStatements } from "../../slices/partner/action";
import { formatDate } from "../../helpers/formatDate";
import Transactions from "./Transactions";
import Pagination from "../../Components/Common/Pagination";
import { partnerRestService } from "../../services/PartnerRestService";

const Statements = () => {
  const dispatch = useDispatch();
  const { partnerStatements } = useSelector((state) => state.partner);
  const { statements, totalPages, totalCount } = partnerStatements;
  const [currentPage, setCurrentPage] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadingIndex, setDownloadingIndex] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getPartnerStatementsFunc();
  }, [currentPage]);

  const getPartnerStatementsFunc = async () => {
    try {
      const data = {
        pageSize: pageSize,
        pageOffset: currentPage - 1,
      };
      await getPartnerStatements(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const downloadStatement = async (ref) => {
    try {
      setIsDownloading(true);
      const res = await partnerRestService({
        method: "post",
        url: "api/v1/partner/statement/download",
        data: { statementRef: ref },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res])); // Create URL from Blob
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `statement_${ref}.pdf`); // Set default file name
      document.body.appendChild(link); // Append link to DOM
      link.click(); // Programmatically click the link to trigger download
      document.body.removeChild(link); // Remove the link element after download
      setIsDownloading(false);
      setDownloadingIndex(null);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="page-content px-4 pb-0">
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: " blur(4px)" }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Statements</h4>
          </div>

          <div className="table-responsive position-relative d-flex flex-column">
            <table className="table table-nowrap table-centered align-middle mb-0">
              <thead className="bg-light text-mute fs-14">
                <tr>
                  <th>#</th>
                  <th>Ref</th>
                  <th>Issuer</th>
                  <th>Country</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Due</th>
                  <th>-</th>
                </tr>
              </thead>
              <tbody className="fs-13">
                {statements?.map((statement, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>#{statement?.statementRef}</td>
                    <td>{statement?.issuerName}</td>
                    <td>{statement?.countryCode}</td>
                    <td>{formatDate(statement?.fromDate, true)}</td>
                    <td>{formatDate(statement?.toDate, true)}</td>
                    <td>AED {statement?.amount}</td>
                    <td>
                      <Transactions statementRef={statement?.statementRef} />
                      <Button
                        color="primary"
                        type="submit"
                        size="sm"
                        className="ms-2"
                        onClick={() => {
                          downloadStatement(statement?.statementRef);
                          setDownloadingIndex(index);
                        }}
                      >
                        {isDownloading && index === downloadingIndex ? (
                          <Spinner size="sm" />
                        ) : (
                          <i className="ri-download-line" />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              totalPages={totalPages}
              totalItems={totalCount}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              itemsPerPage={pageSize}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Statements;
